export const OPERATIONS_RBAC_REFRESH_REQUESTED_EVENT = 'operationsRbacRefreshRequested';

export interface OperationsRbacRefreshDetail {
  userIds?: number[];
  reason?: string;
  requestedAt?: string;
}

function normalizeRefreshUserIds(
  userIds?: Array<number | string | null | undefined>,
): number[] {
  if (!Array.isArray(userIds)) {
    return [];
  }

  return Array.from(new Set(
    userIds
      .map((value) => Number(value))
      .filter((value) => Number.isFinite(value))
  ));
}

export function requestOperationsRbacRefresh(
  userIds?: Array<number | string | null | undefined>,
  reason = 'manual',
) {
  if (typeof window === 'undefined') {
    return;
  }

  const normalizedUserIds = normalizeRefreshUserIds(userIds);
  const detail: OperationsRbacRefreshDetail = {
    reason,
    requestedAt: new Date().toISOString(),
  };

  if (normalizedUserIds.length > 0) {
    detail.userIds = normalizedUserIds;
  }

  window.dispatchEvent(new CustomEvent<OperationsRbacRefreshDetail>(
    OPERATIONS_RBAC_REFRESH_REQUESTED_EVENT,
    { detail },
  ));
}

export function isOperationsRbacRefreshRequestedForUser(
  detail: OperationsRbacRefreshDetail | null | undefined,
  userId?: number | null,
): boolean {
  if (!Number.isFinite(userId)) {
    return true;
  }

  const normalizedUserIds = normalizeRefreshUserIds(detail?.userIds);
  return normalizedUserIds.length === 0 || normalizedUserIds.includes(Number(userId));
}